'use strict';
import address from './address';
import billing from './billing';
import shipping from './shipping';
import validator from '../../validator';
import newAddressForm from '../../addressForm/address-form';

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
export default {
    init: function () {
        newAddressForm.init();
        validator.initCountryChangeValidation();
        address.init();
        if ($('.checkout-shipping').length > 0) {
            shipping.init();
        } else {
            billing.init();
        }

        //if on the order review page and there are products that are not available diable the submit order button
        if ($('.order-summary-footer').length > 0) {
            if ($('.notavailable').length > 0) {
                $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
            }
        }
    }
};
